// src/pages/ToolPlaceholder.js
import React from 'react';
import { useLocation } from 'react-router-dom';

export default function ToolPlaceholder() {
  const location = useLocation();
  const toolName = location.pathname.split('/').pop().replace(/-/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase());

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: 64, marginBottom: 20 }}>🚧</div>
      <div style={{
        fontFamily: 'var(--font-display)',
        fontSize: 28,
        fontWeight: 700,
        color: 'var(--ka-navy)',
        marginBottom: 10,
      }}>
        {toolName}
      </div>
      <div style={{
        fontSize: 15,
        color: 'var(--ka-gray-600)',
        maxWidth: 400,
        lineHeight: 1.6,
      }}>
        This tool is coming soon. Check back later or contact the development team.
      </div>
    </div>
  );
}
